// src/lib/videoPreview.ts
//
// Aperçu d'une version dans un lecteur `<video preload="metadata">` (portail et admin) : le fragment
// `#t=0.5` montre l'image de la demi-seconde sans rien télécharger d'autre que les métadonnées.
// Comme ce fragment fait aussi partir la lecture de 0,5 s, la première lecture repart du début
// (`restartOnFirstPlay`, sur l'évènement `play`, fiable sur Safari iOS et Chrome).

/** Adresse du lecteur : le fichier, avec l'image d'aperçu à 0,5 s. */
export function previewSrc(fileUrl: string): string {
  return `${fileUrl}#t=0.5`
}

/** À brancher sur `onPlay` : la première lecture partie de l'aperçu revient à 0. */
export function restartOnFirstPlay(video: HTMLVideoElement): void {
  if (video.dataset['played'] === '1') return
  video.dataset['played'] = '1'
  if (video.currentTime > 0 && video.currentTime <= 0.6) video.currentTime = 0
}
